import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-91b9c3cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stories" }
const _hoisted_2 = { class: "flex itemscenter justify-between" }
const _hoisted_3 = { class: "mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_story_form = _resolveComponent("story-form")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_stories_list_item = _resolveComponent("stories-list-item")!
  const _component_list = _resolveComponent("list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.form_state.is_opened)
      ? (_openBlock(), _createBlock(_component_story_form, {
          key: 0,
          "is-create": _ctx.form_state.is_create,
          "is-update": _ctx.form_state.is_update,
          story: _ctx.form_state.story,
          onCancel: _ctx.closeForm,
          onSaved: _ctx.onFormSave
        }, null, 8, ["is-create", "is-update", "story", "onCancel", "onSaved"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_page_title, { title: "Истории МПП" }),
            _createVNode(_component_the_button, {
              class: "primary small",
              onClick: _ctx.startCreate
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Добавить историю ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            (_ctx.state.is_failed && !_ctx.state.failure.error_state.is_cancel)
              ? (_openBlock(), _createBlock(_component_failed_fetch, {
                  key: 0,
                  loading: _ctx.state.is_loading,
                  text: "При получении списка историй произошла ошибка",
                  "error-message": _ctx.state.failure.error_state.message,
                  "error-url": _ctx.state.failure.error_state.url,
                  "error-status": _ctx.state.failure.error_state.status,
                  onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadStories(_ctx.state.pagination.current_page)))
                }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
              : (_openBlock(), _createBlock(_component_list, {
                  key: 1,
                  loading: _ctx.state.is_loading,
                  items: _ctx.state.list,
                  pagination: "",
                  "pagination-current-page": _ctx.state.pagination.current_page,
                  "pagination-total-pages": _ctx.state.pagination.total_pages,
                  onChangePage: _ctx.loadStories
                }, {
                  item: _withCtx(({ item, index }) => [
                    _createVNode(_component_stories_list_item, {
                      item: item,
                      onUpdate: _ctx.startUpdate,
                      onPublished: () => _ctx.onStoryPublished(index),
                      onUnpublished: () => _ctx.onStoryUnpublished(index),
                      onDeleted: () => _ctx.onStoryDeleted(index)
                    }, null, 8, ["item", "onUpdate", "onPublished", "onUnpublished", "onDeleted"])
                  ]),
                  _: 1
                }, 8, ["loading", "items", "pagination-current-page", "pagination-total-pages", "onChangePage"]))
          ])
        ], 64))
  ]))
}